<template>
  <div class="my-4">
    <section class="d-flex justify-content-end my-4">
      <b-skeleton width="8rem"></b-skeleton>
    </section>
    <section v-for="(item, index) in notificationsList" :key="index">
      <section class="d-flex justify-content-between">
        <b-skeleton width="14rem" height="1.5rem" class="mb-2"></b-skeleton>
        <span class="material-icons text-muted">expand_more</span>
      </section>
      <section v-for="notification in item.notifications" :key="notification">
        <b-skeleton width="10rem"></b-skeleton>
        <b-card class="my-4 shadow atm-rounded">
          <section class="d-flex align-items-end gap-2 mb-2">
            <b-skeleton type="avatar" width="3rem" height="3rem"></b-skeleton>
            <section class="w-75">
              <b-skeleton width="100%"></b-skeleton>
              <b-skeleton width="8rem" height="0.6rem"></b-skeleton>
            </section>
          </section>
        </b-card>
      </section>
    </section>
  </div>
</template>

<script>
export default {
  data() {
    return {
      notificationsList: [
        {
          notifications: [1],
        },
        {
          notifications: [1, 2],
        },
        {
          notifications: [1],
        },
      ],
    };
  },
};
</script>
